import { captureException } from '@sentry/browser';
import clientConfig from '../client/config';

const componentDidCatch = (error: Error, _info: Object) => {
  if (
    clientConfig.sentry &&
    clientConfig.sentry.dsn &&
    clientConfig.sentry.config
  ) {
    captureException(error);
  } else if (process.env.NODE_ENV !== 'test') {
    console.log(error);
  }
};

export default componentDidCatch;
